// @ts-expect-error untyped module reference-resolvers
import { INBOUND_DB_LISTS } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error untyped module customer-data-reference-ui-components
import ReferenceName from 'customer-data-reference-ui-components/name/ReferenceName';
import { objectListUrl } from 'automation-ui-references/routing/hubspotUrls';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Example:
 *   <ObjectListName id="123" />
 * Renders as:
 *   My List Name
 */
const ObjectListName = ({
  id,
  href,
  messageKey
}) => /*#__PURE__*/_jsx(ReferenceName, {
  href: href || objectListUrl(id),
  id: id,
  messageKey: messageKey,
  referenceObjectType: INBOUND_DB_LISTS
});
export default ObjectListName;